import { render, staticRenderFns } from "./UIMessageDialog.vue?vue&type=template&id=74fd5a34"
import script from "./UIMessageDialog.vue?vue&type=script&lang=ts"
export * from "./UIMessageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports